<template lang="pug">
  v-container#victim(fluid)
    v-form
      v-row
        v-col#top(xs=6 sm=6)
          h1.form-title2.accent-text Datos de la víctima



      v-row.py-1(justify="space-between")
        v-col(d-flex xs=12 sm=7)
          label.custom.mb-2 Fecha de desaparición
          v-row.py-1.attention-date
            v-col(d-flex xs=3 sm=3)
              v-select(
                label="Día"
            	  v-model="disappearanceDateDay"
                :items="days"
              )
            v-col(d-flex xs=3 sm=3)
              v-select(
                label="Mes"
                v-model="disappearanceDateMonth"
                :items="months"
              )
            v-col(d-flex xs=5 sm=5)
              v-autocomplete(
                label="Año"
                v-model="disappearanceDateYear"
                :items="years"
              )


        v-col.upload(d-flex xs=12 sm=5)
          p.bold.underline(@click="pickFile" v-if="!photo") Cargar fotografía
            span.ml-2
              font-awesome-icon(icon="upload" size="lg")
          input(
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="uploadPicture"
          )

          v-flex.upload.px-3(d-flex xs12 sm6 v-if="photo.length > 0")
            p.small.underline.dark-text.text-xs-right(@click="deletePhoto()") Eliminar fotografía
      v-row.py-1(align="end" justify="space-between")
        v-col.pr-2(d-flex xs=12 sm=5)
          v-autocomplete(
          	v-model="disappearanceState"
          	label="Estado"
          	:items="states"
          )
        v-col.pr-2(d-flex xs=12 sm=6)
          v-autocomplete(
          	v-model="disappearanceMun"
          	label="Municipio"
          	:items="municipalities"
          )

      v-row.py-1(align="end" justify="space-between")
        v-col.pr-2(d-flex xs=12 sm=5)
          v-text-field(
          	label="Nombre de desaparecidx"
          	v-model="victimName"
          )
        v-col.pr-2(d-flex xs=12 sm=6)
          v-row
            label.custom.mb-2 Sexo
          v-radio-group(v-model="victimSex" row hide-details)
            v-radio(
            	v-for="(sexOpt, i) in sexOpts"
            	:key="`sexOpt${i}`"
            	:value="i"
            	:label="sexOpt.name"
            )

      v-row.py-1(justify="space-between")
        v-col(d-flex xs=12 sm=5)
          v-menu(
            v-model="birthDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            max-width="290px"
          )
            template(
              v-slot:activator="{ on }"
            )
              v-text-field(
                :value="formatDate(birthDate)"
                label="Fecha de nacimiento"
                readonly
                v-on="on"
              )
            v-date-picker(v-model="birthDate" @input="birthDateMenu = false" color="grey lighten-2")
        v-col(d-flex xs=12 sm=6)
          v-autocomplete(
          	v-model="disappearanceAge"
          	label= "Edad al momento de los hechos"
            :items = "dissapearanceAgeOpts"

          )

      v-row.py-1(justify="space-between")
        v-col(d-flex xs=12 sm=5)
          v-autocomplete(
          	v-model="residenceState"
          	label="Lugar de residencia"
          	:items="states"
          )
        v-col(d-flex xs=12 sm=6)
          v-autocomplete(
          	:items="residenceMunicipalities"
          	v-model="residenceMun"
          	label="Municipio de residencia"
          )
        v-col(d-flex xs=12 sm=6)
          v-text-field(
          	v-model="occupation"
          	label="Trabajo / escuela:"
          )

      v-row.py-1(justify="space-between")

        v-col(d-flex xs=12 sm=5)
          v-text-field(
          	v-model="residenceNeighbourhood"
          	label="Colonia de residencia"
          )

        v-col(d-flex xs=12 sm=6)
          v-text-field(
          	v-model="disappearanceNeighbourhood"
          	label="Colonia en la que desapareció"
          )

      v-row.py-1(justify="space-between")
        v-col(d-flex xs=12 sm=5)
          v-autocomplete(
          	label="Dependientes económicos"
          	v-model="economicDependants"
            :items="economicDependantsOpts"
          )

      v-row.py-1(justify="space-between")
        v-col(d-flex xs=12 sm=7)
          v-text-field(
          	v-model="partner"
          	label="Nombre de Cónyuge"
          )

</template>

<script>
import $mx from "../../services/mx.service.js";
import * as _ from "lodash";

export default {
  name: "VictimData",
  data() {
    return {
      folio: this.$store.state.record.folio,
      states: $mx.getStates().sort(),
      disappearDateMenu: false,
      birthDateMenu: false,
      dissapearanceAgeOpts: [...Array(100).keys()].slice(1),
      economicDependantsOpts: [...Array(11).keys()],
      sexOpts: [
        { 'name': 'Hombre', 'slug': 'man' },
        { 'name': 'Mujer', 'slug': 'woman' }
      ]
    };
  },
  computed: {
    days() {
      return this.$store.state.days;
    },
    months() {
      return this.$store.state.months;
    },
    years() {
      return this.$store.state.years;
    },
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    disappearanceDateDay: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceDate.day;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceDate.day = value;
    	}
    },
    disappearanceDateMonth: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceDate.month;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceDate.month = value;
    	}
    },
    disappearanceDateYear: {
      get() {
    		return this.$store.state.record.victimData.disappearanceDate.year;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceDate.year = value;
    	}
    },
    // disappearanceDate: {
    //   get() {
    //     return this.$store.state.record.victimData.disappearanceDate;
    //   },
    //   set(value) {
    //     this.$store.state.record.victimData.disappearanceDate = value;
    //   }
    // },
    disappearanceState: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceState;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceState = value;
    	}
    },
    disappearanceMun: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceMun;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceMun = value;
    	}
    },
    victimName: {
    	get() {
    		return this.$store.state.record.victimData.name;
    	},
    	set(value) {
    		this.$store.state.record.victimData.name = value;
    	}
    },
    victimSex: {
      get() {
        return this.sexOpts.findIndex(sexOpt =>
          sexOpt.slug == this.$store.state.record.victimData.sex.slug
        );
      },
      set(index) {
        this.$store.state.record.victimData.sex = this.sexOpts[index];
      }
    },
    birthDate: {
    	get() {
    		return this.$store.state.record.victimData.birthDate;
    	},
    	set(value) {
    		this.$store.state.record.victimData.birthDate = value;
    	}
    },
    disappearanceAge: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceAge;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceAge = value;
    	}
    },
    residenceState: {
    	get() {
    		return this.$store.state.record.victimData.residenceState;
    	},
    	set(value) {
    		this.$store.state.record.victimData.residenceState = value;
    	}
    },
    residenceMun: {
    	get() {
    		return this.$store.state.record.victimData.residenceMun;
    	},
    	set(value) {
    		this.$store.state.record.victimData.residenceMun = value;
    	}
    },
    occupation: {
    	get() {
    		return this.$store.state.record.victimData.occupation;
    	},
    	set(value) {
    		this.$store.state.record.victimData.occupation = value;
    	}
    },
    residenceNeighbourhood: {
    	get() {
    		return this.$store.state.record.victimData.residenceNeighbourhood;
    	},
    	set(value) {
    		this.$store.state.record.victimData.residenceNeighbourhood = value;
    	}
    },
    disappearanceNeighbourhood: {
    	get() {
    		return this.$store.state.record.victimData.disappearanceNeighbourhood;
    	},
    	set(value) {
    		this.$store.state.record.victimData.disappearanceNeighbourhood = value;
    	}
    },
    partner: {
      get() {
        return this.$store.state.record.victimData.partner;
      },
      set(value) {
        this.$store.state.record.victimData.partner = value;
      }
    },
    economicDependants: {
      get() {
        return this.$store.state.record.victimData.economicDependants;
      },
      set(value) {
        this.$store.state.record.victimData.economicDependants = value;
      }
    },
    municipalities() {
      if (!this.$store.state.record.victimData.disappearanceState) return [];
      else {
        return $mx.getMuns(this.$store.state.record.victimData.disappearanceState).sort();
      }
    },
    residenceMunicipalities() {
      if (!this.$store.state.record.victimData.residenceState) return [];
      else {
        return $mx.getMuns(this.$store.state.record.victimData.residenceState).sort();
      }
    },
    photo: {
      get() {
        return this.$store.state.record.victimData.photo;
      },
      set(value) {
        this.$store.state.record.victimData.photo = value;
      }
    }
  },
  methods: {
    formatDate(value) {
      return value ? new Intl.DateTimeFormat("es").format(new Date(`${value}T00:00`)) : "";
    },
    deletePhoto() {
      this.photo = "";
    },
    pickFile() {
      this.$refs.image.click();
    },
    async uploadPicture(e) {
      let pictureName = e.target.files[0].name;

      try {
        let fileData = await this.getBase64(e.target.files[0]);
        this.photo = fileData;

        /*
        Set image by setting the base64 value of the selected img and not by uploading img to bucket
        let pictureData = {
          folio: "",
          file: fileData,
          descrip: "victima",
          fileName: pictureName
        };
        this.$store.commit("setIsLoadingState", true);

        let uploadImageResponse = await this.$store.dispatch("uploadImage", pictureData);

        this.$store.state.record.victimData.photo = uploadImageResponse.data.url + "?" + new Date().getTime(); */

        /*const updateVictim = {
          folio: pictureData.victimFolio,
          prop: "photo",
          val: uploadImageResponse.data.url + "?" + new Date().getTime()
        };
        this.$store.dispatch("updateVictimInfo", updateVictim);*/
        //this.$store.commit("setIsLoadingState", false);
      } catch {
        this.$store.commit("setIsLoadingState", false);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.col{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.attention-date .v-select {
  padding-top: 0px !important;
}

.upload {
  display: flex;
  align-self: center;
  cursor: pointer;
  p {
    font-size: 0.8rem !important;
  }
  &:hover {
    opacity: 0.7;
  }
}

</style>
